import React from "react";
import { HtmlEditorContainer } from "./styled";
import { useEasyHtmlStore } from "../../../stores/use-easyhtml-store";
import CodeEditor from "../components/CodeEditor";
import Preview from "../components/Preview";
import "../../../css/easy-html.css";

function EasyHTMLEditor() {
  const { mode, contentByMode, theme, updateContentByMode } = useEasyHtmlStore(
    (state) => ({
      mode: state.data.mode,
      contentByMode: state.data.contentByMode,
      theme: state.data.theme,
      updateContentByMode: state.updateContentByMode,
    })
  );

  return (
    <HtmlEditorContainer className="wrapper">
      <CodeEditor
        data={{ codes: contentByMode[mode], mode, theme }}
        handleChange={updateContentByMode}
      />
      <Preview data={{ codes: contentByMode }} />
    </HtmlEditorContainer>
  );
}

export default EasyHTMLEditor;
